import { gql } from "@apollo/client";

export const ADMIN_MONTHLY_SETTLEMENT_PAYOUTS = gql`
  query AdminMonthlySettlementPayouts($yearMonth: String!) {
    adminMonthlySettlementPayouts(yearMonth: $yearMonth) {
      id
      yearMonth
      amount
      paidAt
      memo
      kind
      createdAt
    }
  }
`;

export const ADMIN_DELETE_MONTHLY_SETTLEMENT_PAYOUT = gql`
  mutation AdminDeleteMonthlySettlementPayout($id: Int!) {
    adminDeleteMonthlySettlementPayout(id: $id)
  }
`;
